import { Formik } from 'formik'
import { Col, Form, Modal, ModalHeader, Row } from 'react-bootstrap'
import { CreateTransferItemIssueSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import { useNavigate } from 'react-router-dom'

function ModalItemIssue(props) {
  const titleStyle = {
    fontSize: '12px',
    letterSpacing: '0.5px'
  }
  const { data: dataProp } = props
  const navigate = useNavigate()

  const handleSubmit = (values) => {
    props.onHide()
    navigate('/item-issue/create-transfer', {
      state: {
        warehouse_id:
          dataProp.filter.warehouse_id?.value ?? dataProp.filter.warehouse_id,
        warehouse_name: dataProp.filter.warehouse_id?.label ?? '',
        selectedItems: dataProp.selectedItems,
        selectedID: dataProp.selectedID,
        targetType: values.type
      }
    })
  }

  return (
    <Modal {...props} centered>
      <ModalHeader closeButton>
        <Modal.Title>Create Transfer</Modal.Title>
      </ModalHeader>
      <Modal.Body>
        <Formik
          initialValues={{
            type: ''
          }}
          validationSchema={CreateTransferItemIssueSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
            touched,
            isValid,
            dirty
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label
                      style={titleStyle}
                      className="fw-bold text-secondary text-uppercase"
                      htmlFor={'type'}
                    >
                      <small>
                        Type <sup style={{ color: 'red' }}>*</sup>
                      </small>
                    </Form.Label>
                    <div className="d-flex flex-row gap-2">
                      <div>
                        <Form.Check.Input
                          inline
                          id="karantina"
                          name="karantina"
                          type="radio"
                          className="access-management"
                          checked={values.type === 'karantina'}
                          onChange={() => {
                            setFieldValue('type', 'karantina')
                            setFieldTouched('type', true, false)
                          }}
                          isInvalid={touched.type && !!errors.type}
                        ></Form.Check.Input>
                        <Form.Check.Label className="ms-2" htmlFor="karantina">
                          Quarantine
                        </Form.Check.Label>
                      </div>
                      <div>
                        <Form.Check.Input
                          inline
                          id="reject"
                          name="reject"
                          type="radio"
                          className="access-management"
                          checked={values.type === 'reject'}
                          onChange={() => {
                            setFieldValue('type', 'reject')
                            setFieldTouched('type', true, false)
                          }}
                          isInvalid={touched.type && !!errors.type}
                        ></Form.Check.Input>
                        <Form.Check.Label className="ms-2" htmlFor="reject">
                          Reject
                        </Form.Check.Label>
                      </div>
                    </div>
                    {!!errors.type && touched.type && (
                      <Form.Control.Feedback type="invalid">
                        {errors.type}
                      </Form.Control.Feedback>
                    )}
                  </Col>
                </Row>
                <Modal.Footer>
                  <CustomCloseButton onClick={props.onHide} />
                  <CustomButton
                    onClick={handleSubmit}
                    variant={!isValid || !dirty ? 'secondary' : 'warning'}
                    classNameValue={
                      !isValid || !dirty ? 'opacity-25' : 'text-white'
                    }
                    disabled={!isValid || !dirty}
                    text="Next"
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalItemIssue
